import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { configureAppToast, syncAppToastDirection } from './utilities/appToast';

configureAppToast();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
    </React.StrictMode>
);

store.subscribe(() => {
  const language = store.getState()?.language?.language;
  syncAppToastDirection(language === 'ar');
});

